import { render, staticRenderFns } from "./RegisterFormStepInfos.vue?vue&type=template&id=b6eb4ce4&"
import script from "./RegisterFormStepInfos.vue?vue&type=script&lang=js&"
export * from "./RegisterFormStepInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports